import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const VARIANT_META = {
    taken: {
        iconBg: '#ecfdf3',
        iconColor: '#22c55e',
        accent: '#22c55e',
        scrim: 'rgba(17, 24, 39, 0.12)',
    },
    brand: {
        iconBg: '#fff7c2',
        iconColor: '#8a7000',
        accent: '#ffe566',
        scrim: 'rgba(17, 24, 39, 0.10)',
    },
};

export default function CenterToast({ open, message, subMessage = '', onClick, variant = 'taken' }) {
    if (!open) return null;
    const meta = VARIANT_META[variant] || VARIANT_META.taken;

    return (
        <Box
            onClick={onClick}
            {...(onClick ? { role: 'button', tabIndex: 0 } : {})}
            sx={{
                position: 'fixed',
                inset: 0,
                zIndex: 1900,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                pointerEvents: onClick ? 'auto' : 'none',
                bgcolor: meta.scrim,
            }}
        >
            <Box
                role="alert"
                sx={{
                    width: 'min(calc(100vw - 48px), 320px)',
                    px: 2.4,
                    py: 2.2,
                    borderRadius: 4,
                    bgcolor: '#fff',
                    border: '1px solid #eef0f3',
                    boxShadow: '0 18px 44px rgba(26, 26, 26, 0.20)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                    animation: 'centerToastPop 0.22s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
                    '@keyframes centerToastPop': {
                        from: { opacity: 0, transform: 'scale(0.9) translateY(8px)' },
                        to: { opacity: 1, transform: 'scale(1) translateY(0)' },
                    },
                }}
            >
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 3,
                        bgcolor: meta.iconBg,
                        color: meta.iconColor,
                        border: `1px solid ${meta.accent}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CheckCircleRoundedIcon sx={{ fontSize: 30 }} />
                </Box>
                <Typography sx={{ color: '#111827', fontSize: '1.12rem', fontWeight: 800, textAlign: 'center', lineHeight: 1.35 }}>
                    {message}
                </Typography>
                {subMessage && (
                    <Typography sx={{ color: '#6b7280', fontSize: '0.92rem', fontWeight: 600, textAlign: 'center', lineHeight: 1.45 }}>
                        {subMessage}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
